import { lazy, Suspense } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import NotFound from "../components/Reusable/Notfound";
import ScrollToTop from "../components/Reusable/ScrollToTop";
import PageLoader from "../components/Reusable/PageLoader";

// Route-group shells are code-split so a public visitor (landing page / shared
// campaign link) never downloads the admin, org, or user dashboard bundles.
const WebsiteRoutes = lazy(() => import("./website_routes"));
const UserRoutes = lazy(() => import("./user_routes"));
const AdminRoutes = lazy(() => import("./admin_routes"));
const OrganisationRoutes = lazy(() => import("./oganisation_routes"));

function AppRoutes() {
  return (
    <Router>
      <ScrollToTop /> {/* ensures all pages scroll to top on route change */}
      <Suspense fallback={<PageLoader />}>
        <Routes>
          <Route path="/*" element={<WebsiteRoutes />} />
          <Route path="/user/*" element={<UserRoutes />} />
          <Route path="/admin/*" element={<AdminRoutes />} />
          <Route path="/org/*" element={<OrganisationRoutes />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
    </Router>
  );
}

export default AppRoutes;
